import { bind } from '../../../../../shared/helpers/decorators';
import { EventEmitter } from '../../../../../shared/helpers/event-emitter';
import { onStreamStartCallback } from '../../../../../shared/helpers/host-api';
import { FileRecorder, FileRecorderCloseResult } from './types';

interface RecorderOptions {
    url: string;
}

export class WSRecorder extends EventEmitter implements FileRecorder {
    private readonly ws: WebSocket;
    private readonly options: RecorderOptions;
    private chunkNumber: number;

    constructor(options: RecorderOptions) {
        super();

        this.options = options;
        this.ws = new WebSocket(options.url);
        this.ws.addEventListener('message', this.handleMessage);
        this.chunkNumber = 0;
    }

    @bind
    init() {
        return Promise.resolve();
    }

    @bind
    private handleMessage(event: MessageEvent) {
        const data = JSON.parse(event.data);

        if (typeof onStreamStartCallback === 'function' && ['ok', 'error'].includes(data.status)) {
            onStreamStartCallback(data);
        }

        if (data.status === 'restart') {
            this.emit('restart');
        }
    }

    addChunk(chunk: Blob): Promise<void> {
        this.chunkNumber++;
        this.ws.send(chunk);
        // eslint-disable-next-line no-console
        console.log(`Sending chunk ${this.chunkNumber}`);
        return Promise.resolve();
    }

    close(): Promise<FileRecorderCloseResult> {
        this.ws.close();
        return Promise.resolve({ status: 'saved' });
    }
}
